export const createObjectivePathKeys = (scope?: string) => {
  const [authority, publication, document, section] = scope?.split("#") ?? [];

  const authorityKey = { id: authority, sk: "authority" };
  const publicationKey = {
    id: authority,
    sk: ["publication", authority, publication].join("#"),
  };
  const documentKey = {
    id: authority,
    sk: ["document", authority, publication, document].join("#"),
  };
  const sectionKey = {
    id: authority,
    sk: ["section", authority, publication, document, section].join("#"),
  };

  return {
    authorityKey,
    publicationKey,
    documentKey,
    sectionKey,
  };
};
